<h2 class="social-dialog-title" mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content>
  <span class="modal-text-primary"> {{ subtitle }} </span>
  <div class="video-container">
    <div style="padding: 75% 0 0 0; position: relative">
      <iframe
        id="demoFlowIframe"
        [src]="videoSrc | safeHtml: 'resourceUrl'"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        title="demo flow video"
      >
      </iframe>
    </div>
  </div>
  <button mat-button (click)="btnClicked()" class="social-modal-button">
    {{ buttonText }}
  </button>
</mat-dialog-content>
